export function ZipcodeMask(): string {
  return '00000-000';
}
